<template>
  <div>
    <Table
      :title="$t(`mainProject.title`)"
      :searchPlaceholder="$t(`mainProject.searchPlaceholder`)"
      @click:row="CLICK_ROW"
      no-card
      :items="filteredItems"
      @change:search="CHANGE_SEARCH"
      :headers="headers"
      i18n
    >
      <template #new-button>
        <div class="u-display-flex u-width-100% u-justify-content-flex-end">
          <ExcelExport
            :fileName="`${project.model}-${$t(
              `mainProject.title`
            )}-export-${$date.format(new Date())}`"
            :fields="exportFields"
            :data="filteredItems"
          >
            <template #button="{ showExcell }">
              <Button
                @click="showExcell()"
                variant="light-success"
                class="u-margin-right-xsmall"
              >
                <i class="icofont-arrow-up"></i> {{ $t("common.export") }}
              </Button>
            </template>
          </ExcelExport>

          <Button variant="light-primary" @click="ADD_MAIN_PROJECT">
            + {{ $t(`project.addToMainProject`) }}
          </Button>
        </div>
      </template>
      <template #isActive="{ item }">
        <chip
          class="u-margin-0"
          :variant="item.isActive ? 'success' : 'danger'"
        >
          {{ item.isActive ? $tc("common.active") : $tc("common.passive") }}
        </chip>
      </template>
      <template #createdDate="{ item }">
        {{ $date.format(item.createdDate) }}
      </template>
      <template #series="{ item }">
        {{ item.seriesInfo.title }}
      </template>
    </Table>
    <AddMainProjectToProject
      v-model="addMainProjectToProject"
      @refresh="refresh"
      :form="project"
    ></AddMainProjectToProject>
  </div>
</template>

<script>
import Table from "@/components/Base/Table/index.vue";
import Chip from "@/components/Base/Chip.vue";
import ExcelExport from "@/components/Base/ExcelExport.vue";
import Button from "@/components/Base/Button.vue";
import AddMainProjectToProject from "@/components/ProjectMainProjects/AddMainProjectToProject.vue";
export default {
  components: { Table, Chip, ExcelExport, Button, AddMainProjectToProject },
  props: {
    project: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      search: "",
      addMainProjectToProject: false,
      headers: [
        {
          col: 12,
          sm: 4,
          md: 4,
          lg: 4,
          title: "mainProject.title",
          value: "title",
        },
        {
          col: 12,
          sm: 3,
          md: 3,
          lg: 3,
          title: "series.title",
          value: "series",
        },
        {
          col: 12,
          sm: 3,
          md: 3,
          lg: 3,
          title: "common.createdDate",
          value: "createdDate",
        },
        {
          col: 12,
          sm: 2,
          md: 2,
          lg: 2,
          title: "common.isActive",
          value: "isActive",
        },
      ],
    };
  },
  computed: {
    query() {
      return {
        projectId: this.project.id,
      };
    },
    filteredItems() {
      return this.project.mainProjectInfos.filter((item) =>
        item.title.toLowerCase().includes(this.search.toLowerCase())
      );
    },
    exportFields() {
      return {
        [this.$t("project.model")]: {
          field: "model",
          callback: () => {
            return this.project.model;
          },
        },
        [this.$t("mainProject.title")]: {
          field: "title",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("series.title")]: {
          field: "seriesInfo.title",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("common.createdDate")]: {
          field: "createdDate",
          callback: (value) => {
            return this.$date.format(value);
          },
        },
        [this.$t("common.isActive")]: {
          field: "isActive",
          callback: (value) => {
            return value
              ? this.$tc("common.active")
              : this.$tc("common.passive");
          },
        },
      };
    },
  },
  methods: {
    ADD_MAIN_PROJECT() {
      this.addMainProjectToProject = true;
    },
    CHANGE_SEARCH(search) {
      this.search = search;
    },
    CLICK_ROW(item) {
      this.$router.push({
        name: "main-projects-id",
        params: { mainProjectId: item.id },
      });
    },
    refresh() {
      this.$emit("refresh");
    },
  },
};
</script>

<style></style>
